
export default {
  layout: 'technos',
  data() {
    return {
      curso: {
        duracao: [
          'O curso pode ser concluído em 6 meses, 1x por semana, nas quartas-feiras das 19h às 22h',
          'Ou em 3 meses, 2x por semana, nas segundas-feiras e sextas-feiras das 19h às 22h',
        ],
        carga_horaria: '72 horas',
        investimento: [{ forma: 'cartão', label: '6 x', valor: 'R$ 260,00' }],
        modulos: [
          {
            titulo: 'Formação Profissional',
            descricao: {
              'Gestão de Carreira:  ': [
                'Autoconhecimento, planejamento de carreira e gestão do tempo;',
                'Ferramentas de organização e produtividade;',
                'Pensamento crítico, criatividade e inteligência emocional;',
              ],
              'Marketing Pessoal: ': [
                'Introdução ao Marketing Pessoal; ',
                'Currículo: o que devo ou não colocar; ',
                'Como usar redes sociais para carreira: o que postar e o que não postar; ',
                'Elaborar currículos e cartas de apresentação; ',
                'Criar e usar conta no Linkedin; ',
                'Comunicação efetiva, criatividade e empatia; ',
              ],
              'Mercado de trabalho: ': [
                'Futuro do mercado de trabalho; ',
                'Análise de vagas e aproveitamento de oportunidades; ',
                'Pesquisa de vagas e cadastro nos portais de estágios; ',
                'Pensamento crítico, adaptabilidade e resiliência; ',
              ],
              'Comunicação profissional: ': [
                'Importância e princípios da comunicação profissional; ',
                'Como se portar na entrevista; ',
                'Uso de tecnologias para videoconferência; ',
                'Ferramentas de colaboração e espaços de trabalho virtuais; ',
                'Comunicação efetiva, inteligência emocional e trabalho em equipe; ',
              ],
            },
          },
          {
            titulo: 'Rotinas Administrativas',
            descricao: {
              'Rotinas:  ': [
                'Conceitos básicos de administração e a importância das rotinas administrativas; ',
                'Tarefas comuns nas rotinas administrativas; ',
                'Resolução de problemas, comunicação efetiva e resiliência; ',
              ],
              'Organização: ': [
                'Técnicas de organização e gerenciamento do tempo para aumentar a produtividade;',
                'Elaboração de cronogramas e calendários',
                'Elaborar planilha com formatação simples',
                'Organização e pensamento crítico',
              ],
              'E-mail: ': [
                'Atendimento via e-mail e outros aplicativos de mensagens;',
                'Importância da comunicação eficaz no contexto profissional;',
                'Gestão de e-mail;',
                'Comunicação efetiva e empatia;',
              ],
              'Serviços Postais: ': [
                'Tipos de correspondências; ',
                'Correios e Transportadoras;',
                'Preencher um envelope; ',
                'Rastreio de correspondências;',
                'Comunicação efetiva e organização.',
              ],
            },
          },
          {
            titulo: 'Gestão de Documentos',
            descricao: {
              'Fluxo documental:  ': [
                'Tipos de documentos; ',
                'Fluxo de gestão e arquivamento;',
                'Boas práticas de segurança e confidencialidade no manuseio de informações sensíveis;',
              ],
              'Comunicados e Atas:  ': [
                'O que são comunicados e atas, e como redigi-los; ',
                'Elaborar documentos com formatação simples; ',
              ],
              'Recibos e Notas Fiscais: ': [
                'O que são recibos e notas fiscais e como redigir; ',
                'Elaborar documentos com tabelas; ',
              ],
              'Relatórios e apresentações: ': [
                'O que são relatórios e como redigir;',
                'Comunicação oral e escrita;',
                'Boas práticas de apresentações;',
                'Elaborar documentos e apresentações com imagens e gráficos.',
              ],
            },
          },
          {
            titulo: 'Finanças',
            descricao: {
              'Controle bancário:  ': [
                'Cheques, Boletos, Transferências, PIX, Extrato;  ',
                'Elaborar planilha com formatação e cálculos simples;',
              ],

              'Contas a pagar:  ': [
                'Controle das despesas e programação dos pagamentos; ',
                'Elaborar planilha com formatação condicional;',
              ],

              'Contas a receber: ': [
                'Processo de cobrança e controle de recebimentos; ',
                'Elaborar planilha com gráficos;',
              ],

              'Fluxo de caixa: ': [
                'Preenchimento e controle de fluxo de caixa; ',
                'Elaborar planilha com validação de dados.',
              ],
            },
          },
          {
            titulo: 'Atendimento & Vendas',
            descricao: {
              'Atendimento:  ': [
                'Marketing pessoal no contexto do atendimento; ',
                'Excelência no atendimento ao cliente;  ',
                'Ferramentas do WhatsApp para atendimento; ',
              ],
              'Venda:  ': [
                'Etapas de uma venda; ',
                'Técnicas de venda; ',
                'Uso de funil de vendas; ',
                'Pipeline; ',
                'Leads e métricas comerciais; ',
              ],
              'Cliente: ': [
                'Tipos de cliente e abordagens;',
                'Venda adicional e pós-venda; ',
                'Pontuação e tags de clientes; ',
              ],
              'Autogestão de eficiência: ': [
                'Acompanhamento de metas; ',
                'Avaliação e aumento da eficiência pessoal; ',
                'Análise e apresentação de dados com gráficos. ',
              ],
            },
          },
          {
            titulo: 'Noções de Marketing e Design',
            descricao: {
              'Marketing:  ': [
                'O que é Marketing e seus objetivos; ',
                'Princípios de design (cores, fontes, alinhamento); ',
              ],
              'Posts e Stories:  ': [
                'Planejamento de postagens; ',
                'Post e Stories para redes sociais; ',
              ],
              'Vídeos: ': [
                'Vídeo Marketing e como utilizar;',
                'Edição de vídeos; ',
              ],
              'Redes sociais: ': ['Postagens, campanhas e impulsionamento. '],
            },
          },
        ],
      },
    }
  },
}
